import React, { useState } from 'react';

import { Formik, Field } from 'formik';
import { Row, Col } from 'antd';
import * as Yup from 'yup';

import styled from 'styled-components';

import { EventSubTypeColorsList } from '@constants/SwatchColors';

import { DEFAULT_FOLDER_COLOR, getFolderColorPayload } from '@libs/NwFolders';

import { useCreateFolder } from '@hooks/API/UseFolders';
import useFormFieldFocus from '@hooks/Utils/UseFormFieldFocus';

import { NwCancelButton, NwSaveButton } from '@components/Gui/NwButton';
import NwDrawer from '@components/Gui/NwDrawer';
import {
    NWInput,
    NWPrivacyLevelSelector,
    NWSwatchPicker,
    NWTextAreaCharCounter,
} from '@components/Gui/NwForm/NwFormItems';
import { NwForm, NwFormButtonsBar } from '@components/Gui/NwForm/NwFormWrapper';

//stessa spaziatura tra i campi del drawer di modifica
const FieldsBlock = styled.div`
    .nw-form-item-container {
        margin-bottom: 1rem;
    }
`;

//solo creazione: rename e modifica di una folder esistente sono in FolderManageDrawer, che salva da solo
const FolderDrawer = ({ type, onClose, items, onCreated, zIndex }) => {
    const [touchForm, onTouchForm] = useState(false);
    useFormFieldFocus('Name');

    const { mutateAsync: createFolder } = useCreateFolder();

    const initialValues = {
        Name: '',
        Description: '',
        Color: DEFAULT_FOLDER_COLOR,
        PrivacyLevel: 'User',
    };

    let validationSchema = Yup.object().shape({
        Name: Yup.string().required('Name is required'),
        Color: Yup.string().required('Color is required'),
    });

    const submitForm = async (values, setSubmitting) => {
        setSubmitting(true);
        try {
            const newFolder = await createFolder({
                Name: values.Name,
                Description: values.Description,
                Type: type || 'model', //implicito: dipende da dove si apre il form
                Color: getFolderColorPayload(values.Color),
                PrivacyLevel: values.PrivacyLevel,
                ContactIDs: items ? items : [],
            });
            if (onCreated) {
                onCreated(newFolder.ID, newFolder.Name);
            }
            onTouchForm(false);
            setSubmitting(false);
            onClose();
        } catch (error) {
            console.error('Create Folder Error => ', error);
            setSubmitting(false);
        }
    };

    return (
        <NwDrawer
            touchForm={touchForm}
            onTouchForm={onTouchForm}
            onClose={onClose}
            zIndex={zIndex}
            title="Create a new folder"
        >
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values, { setStatus, setSubmitting }) => {
                    setStatus();
                    submitForm(values, setSubmitting);
                }}
            >
                {({ isSubmitting, values, handleSubmit }) => (
                    <NwForm values={values} onTouchForm={onTouchForm} onFinish={handleSubmit} layout="vertical">
                        <FieldsBlock>
                            <Row gutter={16}>
                                <Col flex="auto">
                                    <Field
                                        component={NWInput}
                                        label="Name"
                                        name="Name"
                                        type="text"
                                        required
                                        id="Name"
                                        value={values.Name}
                                    />
                                </Col>
                                <Col flex="none">
                                    <Field
                                        component={NWSwatchPicker}
                                        label="Color"
                                        name="Color"
                                        required
                                        compact
                                        placement="left"
                                        colorsList={EventSubTypeColorsList}
                                        defaultColor={values.Color}
                                        value={values.Color}
                                    />
                                </Col>
                            </Row>
                            <Field
                                component={NWTextAreaCharCounter}
                                label="Description"
                                name="Description"
                                type="text"
                                maxLength={500}
                                autoSize={{ minRows: 3, maxRows: 3 }}
                                value={values.Description}
                            />
                            <Field
                                component={NWPrivacyLevelSelector}
                                label="Privacy Level"
                                name="PrivacyLevel"
                                hasDepartment
                                hasNetworkAgency
                                value={values.PrivacyLevel}
                            />
                        </FieldsBlock>
                        <NwFormButtonsBar
                            marginTop="4rem"
                            left={
                                <NwCancelButton
                                    disabled={isSubmitting}
                                    onClick={() => {
                                        onTouchForm(false);
                                        onClose();
                                    }}
                                />
                            }
                            right={<NwSaveButton htmlType="submit" disabled={isSubmitting} loading={isSubmitting} />}
                        />
                    </NwForm>
                )}
            </Formik>
        </NwDrawer>
    );
};

export default FolderDrawer;
